import React, { Component } from 'react'
import { Map, List, fromJS } from 'immutable'
import { Button } from 'semantic-ui-react'
import { connectForm, ModalForm, Group, Form, Field, Submit, InfoGroup, Info } from '~/form'
import { createTask } from '../actions'
import moment from 'moment'
import TaskForm, { TaskFormValidations } from './form'
import { fetchTaskTypes } from '~/taskType/actions'

class TaskAdd extends Component {
  static formSubmit(dispatch, formId, values, changed) {
    dispatch(createTask(formId, values.toJS()))
  }

  static formValidation = TaskFormValidations

  componentWillMount = () => {
    let { project, interview, order, formInit, user_id, task_type_id, organization_id } = this.props

    let initialValues = {
      user_id,
      status: 'pending',
      deadline: moment().set({ hour: 12, minute: 0, second: 0, millisecond: 0 }).toDate(),
      data: {
        enableCalendarSync: true,
      },
    }
    if (project) initialValues.project_id = project.get('id')

    if (interview) initialValues.interview_id = interview.get('id')

    if (order) initialValues.order_id = order.get('id')

    if (task_type_id) initialValues.task_type_id = task_type_id

    if (organization_id) initialValues.organization_id = organization_id

    formInit(initialValues)
  }

  componentDidMount = () => {
    let { typesLoading, fetchTaskTypes } = this.props
    if (typesLoading) fetchTaskTypes()
  }

  render() {
    let { formUpdate, formSubmit, formState, formLoading, onClose, person, types, typesLoading } = this.props

    let actions = (
      <Button
        size="tiny"
        color="green"
        content="Tallenna"
        onClick={e => e.preventDefault() & formSubmit()}
        icon="save"
      />
    )

    return (
      <ModalForm id="task-add" onSubmit={formSubmit} formState={formState} actions={actions} onClose={onClose}>
        <TaskForm {...this.props} title="Lisää tehtävä" />
      </ModalForm>
    )
  }
}

function mapStateToProps(state) {
  return {
    types: state.taskTypes,
    typesLoading: state.taskTypesLoading,
    user_id: state.authUser.id,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    fetchTaskTypes: () => dispatch(fetchTaskTypes()),
  }
}

export default connectForm('person-add', TaskAdd, mapStateToProps, mapDispatchToProps)
